import Client from "../AxiosClient";
const resourceReport = "/private/briefingcollections";

export default {
    async searchReport(id, month, year, departmentId) {
        try {
          if (departmentId === -1) departmentId = "";
          const result = await Client.get(`${resourceReport}/searchreport`, {
                params: {
                    id: id,
                    briefings_month: month,
                    briefings_year: year,
                    department_id: departmentId
                }
            });
          return result;
        } catch (error) {
          return { error: error };
        }
      },
    async insReport(data) {
        try {
          const result = await Client.post(`${resourceReport}`, data);
          return result;
        } catch (error) {
          return { error: error };
        }
    },
    
    async updReport(data) {
        try {
          const result = await Client.put(`${resourceReport}`, data);
          return result;
        } catch (error) {
          return { error: error };
        }
    },
    
    async delReport(id) {
        try {
          const result = await Client.delete(`${resourceReport}/${id}`);
          return result;
        } catch (error) {
          return { error: error };
        }
    },
    
    async getfileReport(id) {
        try {
          const result = await Client.get(`${resourceReport}/getfile`, {
              params: {
                id: id
              }
          });
          return result.data;
        } catch (error) {
          return { error: error };
        }
    },
}